import cx from 'classnames';
import React, { ReactNode } from 'react';
import { getSizeClass, prefix } from '../../utils/main';
import { ModalBsSize } from '../../modal.types';

type ModalDialogProps = {
  dialogClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: ReactNode;
  bsClass?: string;
  bsSize?: ModalBsSize;
};

export const ModalDialog: React.FC<ModalDialogProps> = ({
  dialogClassName,
  className,
  style,
  children,
  bsSize,
  bsClass = 'modal',
}) => {
  const modalStyle = { display: 'block', ...style };

  return (
    <div
      tabIndex={-1}
      role="dialog"
      style={modalStyle}
      className={cx(bsClass, className)}
    >
      <div className={cx(prefix({ bsClass }, 'dialog'), getSizeClass(bsClass, bsSize), dialogClassName)}>
        <div className={prefix({ bsClass }, 'content')} role="document">
          {children}
        </div>
      </div>
    </div>
  );
};

